// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host { font-family: 'DM Sans', 'Segoe UI', sans-serif; }

    /* ─── Bottom bar ─── */
    .bottom-nav {
      position: fixed;
      bottom: 0; left: 0; right: 0;
      z-index: 1050;
      background: #fff;
      border-top: 1.5px solid #f0eafa;
      box-shadow: 0 -4px 24px rgba(109,40,217,.10);
      padding-bottom: env(safe-area-inset-bottom, 0);
    }

    .bottom-nav-inner {
      display: flex;
      height: 60px;
      max-width: 600px;
      margin: 0 auto;
      padding: 0 .25rem;
    }

    .nav-btn {
      flex: 1;
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      gap: 2px;
      background: none; border: none;
      cursor: pointer; position: relative;
      padding: 6px 4px 4px;
      border-radius: 12px;
      color: #9ca3af;
      transition: color .2s;
      -webkit-tap-highlight-color: transparent;
    }
    .nav-btn:active { transform: scale(.92); }
    .nav-btn.active  { color: #7c3aed; }

    .active-bar {
      position: absolute;
      top: 0; left: 50%;
      transform: translateX(-50%);
      width: 32px; height: 3px;
      border-radius: 0 0 3px 3px;
      background: linear-gradient(90deg, #7c3aed, #a78bfa);
    }

    .nav-label {
      font-size: .6rem; font-weight: 500;
      line-height: 1; white-space: nowrap;
    }

    .more-icon-wrap { display: flex; transition: transform .25s; }
    .more-icon-wrap.rotated { transform: rotate(90deg); }

    /* ─── Backdrop ─── */
    .backdrop {
      position: fixed; inset: 0;
      background: rgba(20,5,40,.4);
      -webkit-backdrop-filter: blur(3px);
              backdrop-filter: blur(3px);
      z-index: 1048;
      animation: fadein .2s ease;
    }
    @keyframes fadein { from { opacity: 0; } to { opacity: 1; } }

    /* ─── Drawer ─── */
    .drawer {
      position: fixed;
      bottom: 0; left: 0; right: 0;
      z-index: 1049;
      background: #fff;
      border-radius: 20px 20px 0 0;
      padding: 0 1rem calc(80px + env(safe-area-inset-bottom, 0));
      box-shadow: 0 -8px 40px rgba(109,40,217,.14);
      transform: translateY(100%);
      /* transition applied only when NOT dragging (see TS) */
      transition: transform .35s cubic-bezier(.4,0,.2,1);
      will-change: transform;
      touch-action: none;
    }
    .drawer-open { transform: translateY(0) !important; }

    /* Handle */
    .handle-row {
      display: flex; justify-content: center;
      padding: .75rem 0 .25rem;
      cursor: pointer;
    }
    .handle {
      width: 40px; height: 4px;
      border-radius: 99px;
      background: #d1d5db;
    }

    .drawer-title {
      font-size: .875rem; font-weight: 600;
      color: #374151; margin: .5rem 0 1rem;
      padding: 0 .25rem;
    }

    .drawer-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: .625rem;
    }

    .drawer-item {
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      gap: .5rem;
      background: #faf8ff;
      border: 1.5px solid #f0eafa;
      border-radius: 14px;
      padding: 1rem .5rem;
      cursor: pointer; color: #6b7280;
      transition: all .2s;
      -webkit-tap-highlight-color: transparent;
    }
    .drawer-item:active,
    .drawer-item-active,
    .drawer-item:hover {
      background: #f3eeff; border-color: #c4b5fd; color: #7c3aed;
    }

    .drawer-icon {
      display: flex; align-items: center; justify-content: center;
      width: 44px; height: 44px;
      border-radius: 12px;
      background: #fff; border: 1.5px solid #ede9fb;
    }
    .drawer-item-active .drawer-icon { background: #ede9fb; border-color: #c4b5fd; }

    .drawer-label {
      font-size: .75rem; font-weight: 500;
      text-align: center; line-height: 1.2;
    }
  `, "",{"version":3,"sources":["webpack://./libs/auth/src/lib/components/mobile-bottom-nav.component.ts"],"names":[],"mappings":";IACI,QAAQ,8CAA8C,EAAE;;IAExD,uBAAuB;IACvB;MACE,eAAe;MACf,SAAS,EAAE,OAAO,EAAE,QAAQ;MAC5B,aAAa;MACb,gBAAgB;MAChB,+BAA+B;MAC/B,4CAA4C;MAC5C,8CAA8C;IAChD;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,gBAAgB;MAChB,cAAc;MACd,iBAAiB;IACnB;;IAEA;MACE,OAAO;MACP,aAAa,EAAE,sBAAsB;MACrC,mBAAmB,EAAE,uBAAuB;MAC5C,QAAQ;MACR,gBAAgB,EAAE,YAAY;MAC9B,eAAe,EAAE,kBAAkB;MACnC,oBAAoB;MACpB,mBAAmB;MACnB,cAAc;MACd,qBAAqB;MACrB,wCAAwC;IAC1C;IACA,kBAAkB,qBAAqB,EAAE;IACzC,mBAAmB,cAAc,EAAE;;IAEnC;MACE,kBAAkB;MAClB,MAAM,EAAE,SAAS;MACjB,2BAA2B;MAC3B,WAAW,EAAE,WAAW;MACxB,0BAA0B;MAC1B,oDAAoD;IACtD;;IAEA;MACE,gBAAgB,EAAE,gBAAgB;MAClC,cAAc,EAAE,mBAAmB;IACrC;;IAEA,kBAAkB,aAAa,EAAE,0BAA0B,EAAE;IAC7D,0BAA0B,wBAAwB,EAAE;;IAEpD,qBAAqB;IACrB;MACE,eAAe,EAAE,QAAQ;MACzB,4BAA4B;MAC5B,kCAA0B;cAA1B,0BAA0B;MAC1B,aAAa;MACb,0BAA0B;IAC5B;IACA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;IAE5D,mBAAmB;IACnB;MACE,eAAe;MACf,SAAS,EAAE,OAAO,EAAE,QAAQ;MAC5B,aAAa;MACb,gBAAgB;MAChB,4BAA4B;MAC5B,2DAA2D;MAC3D,4CAA4C;MAC5C,2BAA2B;MAC3B,uDAAuD;MACvD,kDAAkD;MAClD,sBAAsB;MACtB,kBAAkB;IACpB;IACA,eAAe,mCAAmC,EAAE;;IAEpD,WAAW;IACX;MACE,aAAa,EAAE,uBAAuB;MACtC,wBAAwB;MACxB,eAAe;IACjB;IACA;MACE,WAAW,EAAE,WAAW;MACxB,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB,EAAE,gBAAgB;MACpC,cAAc,EAAE,oBAAoB;MACpC,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,qCAAqC;MACrC,YAAY;IACd;;IAEA;MACE,aAAa,EAAE,sBAAsB;MACrC,mBAAmB,EAAE,uBAAuB;MAC5C,UAAU;MACV,mBAAmB;MACnB,2BAA2B;MAC3B,mBAAmB;MACnB,mBAAmB;MACnB,eAAe,EAAE,cAAc;MAC/B,mBAAmB;MACnB,wCAAwC;IAC1C;IACA;;;MAGE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc;IAC5D;;IAEA;MACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;MAC3D,WAAW,EAAE,YAAY;MACzB,mBAAmB;MACnB,gBAAgB,EAAE,2BAA2B;IAC/C;IACA,mCAAmC,mBAAmB,EAAE,qBAAqB,EAAE;;IAE/E;MACE,iBAAiB,EAAE,gBAAgB;MACnC,kBAAkB,EAAE,gBAAgB;IACtC","sourcesContent":["\n    :host { font-family: 'DM Sans', 'Segoe UI', sans-serif; }\n\n    /* ─── Bottom bar ─── */\n    .bottom-nav {\n      position: fixed;\n      bottom: 0; left: 0; right: 0;\n      z-index: 1050;\n      background: #fff;\n      border-top: 1.5px solid #f0eafa;\n      box-shadow: 0 -4px 24px rgba(109,40,217,.10);\n      padding-bottom: env(safe-area-inset-bottom, 0);\n    }\n\n    .bottom-nav-inner {\n      display: flex;\n      height: 60px;\n      max-width: 600px;\n      margin: 0 auto;\n      padding: 0 .25rem;\n    }\n\n    .nav-btn {\n      flex: 1;\n      display: flex; flex-direction: column;\n      align-items: center; justify-content: center;\n      gap: 2px;\n      background: none; border: none;\n      cursor: pointer; position: relative;\n      padding: 6px 4px 4px;\n      border-radius: 12px;\n      color: #9ca3af;\n      transition: color .2s;\n      -webkit-tap-highlight-color: transparent;\n    }\n    .nav-btn:active { transform: scale(.92); }\n    .nav-btn.active  { color: #7c3aed; }\n\n    .active-bar {\n      position: absolute;\n      top: 0; left: 50%;\n      transform: translateX(-50%);\n      width: 32px; height: 3px;\n      border-radius: 0 0 3px 3px;\n      background: linear-gradient(90deg, #7c3aed, #a78bfa);\n    }\n\n    .nav-label {\n      font-size: .6rem; font-weight: 500;\n      line-height: 1; white-space: nowrap;\n    }\n\n    .more-icon-wrap { display: flex; transition: transform .25s; }\n    .more-icon-wrap.rotated { transform: rotate(90deg); }\n\n    /* ─── Backdrop ─── */\n    .backdrop {\n      position: fixed; inset: 0;\n      background: rgba(20,5,40,.4);\n      backdrop-filter: blur(3px);\n      z-index: 1048;\n      animation: fadein .2s ease;\n    }\n    @keyframes fadein { from { opacity: 0; } to { opacity: 1; } }\n\n    /* ─── Drawer ─── */\n    .drawer {\n      position: fixed;\n      bottom: 0; left: 0; right: 0;\n      z-index: 1049;\n      background: #fff;\n      border-radius: 20px 20px 0 0;\n      padding: 0 1rem calc(80px + env(safe-area-inset-bottom, 0));\n      box-shadow: 0 -8px 40px rgba(109,40,217,.14);\n      transform: translateY(100%);\n      /* transition applied only when NOT dragging (see TS) */\n      transition: transform .35s cubic-bezier(.4,0,.2,1);\n      will-change: transform;\n      touch-action: none;\n    }\n    .drawer-open { transform: translateY(0) !important; }\n\n    /* Handle */\n    .handle-row {\n      display: flex; justify-content: center;\n      padding: .75rem 0 .25rem;\n      cursor: pointer;\n    }\n    .handle {\n      width: 40px; height: 4px;\n      border-radius: 99px;\n      background: #d1d5db;\n    }\n\n    .drawer-title {\n      font-size: .875rem; font-weight: 600;\n      color: #374151; margin: .5rem 0 1rem;\n      padding: 0 .25rem;\n    }\n\n    .drawer-grid {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: .625rem;\n    }\n\n    .drawer-item {\n      display: flex; flex-direction: column;\n      align-items: center; justify-content: center;\n      gap: .5rem;\n      background: #faf8ff;\n      border: 1.5px solid #f0eafa;\n      border-radius: 14px;\n      padding: 1rem .5rem;\n      cursor: pointer; color: #6b7280;\n      transition: all .2s;\n      -webkit-tap-highlight-color: transparent;\n    }\n    .drawer-item:active,\n    .drawer-item-active,\n    .drawer-item:hover {\n      background: #f3eeff; border-color: #c4b5fd; color: #7c3aed;\n    }\n\n    .drawer-icon {\n      display: flex; align-items: center; justify-content: center;\n      width: 44px; height: 44px;\n      border-radius: 12px;\n      background: #fff; border: 1.5px solid #ede9fb;\n    }\n    .drawer-item-active .drawer-icon { background: #ede9fb; border-color: #c4b5fd; }\n\n    .drawer-label {\n      font-size: .75rem; font-weight: 500;\n      text-align: center; line-height: 1.2;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
